// Tailwind classes for the v9 prototype's settings pieces (.btn, .pill, .input, table.compact).
const btnBase =
	'inline-flex items-center justify-center gap-2 whitespace-nowrap border font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50';

export const v9 = {
	title: 'text-xl font-normal leading-normal text-gray-900',
	subtitle: 'mt-1 max-w-[72ch] text-base leading-normal text-gray-500',
	btnPrimary: `${btnBase} rounded-lg border-transparent bg-primary-500 px-4 py-2 text-sm leading-5 text-white hover:bg-primary-600`,
	btnSecondary: `${btnBase} rounded-lg border-gray-300 bg-white px-4 py-2 text-sm leading-5 text-primary-700 hover:bg-gray-50`,
	btnNeutral: `${btnBase} rounded-lg border-gray-300 bg-white px-4 py-2 text-sm leading-5 text-gray-900 hover:bg-gray-100`,
	btnWide: 'w-[200px] !px-8 !py-3',
	btnSm: `${btnBase} rounded-md border-gray-300 bg-white px-3 py-1 text-xs leading-[18px] text-primary-700 hover:bg-gray-50`,
	icon: 'h-4 w-4 flex-none',
	iconSm: 'h-3 w-3 flex-none',
	card: 'overflow-hidden rounded-lg border border-gray-200 bg-white',
	cardHead: 'flex flex-wrap items-center justify-between gap-4 px-6 pt-6',
	input:
		'block w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm leading-5 text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500',
	// Filter selects in a card head: fixed width set by the caller, never full width.
	filterSelect:
		'flex-none rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm leading-5 text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500',
	inputLg:
		'block w-full rounded-lg border border-gray-300 bg-white px-4 py-3 text-sm leading-5 text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500',
	searchInput:
		'block w-full rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-4 text-sm leading-5 text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500',
	searchIcon:
		'pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400',
	label: 'mb-2 block text-sm font-medium text-gray-700',
	help: 'mt-1 text-xs text-gray-500',
	th: 'whitespace-nowrap border-b border-gray-200 bg-gray-50 px-4 py-2.5 text-left text-xs font-medium uppercase tracking-[.05em] text-gray-500',
	tbody: '[&>tr:last-child>td]:border-b-0',
	td: 'whitespace-nowrap border-b border-gray-200 px-4 py-2.5 align-middle text-sm text-gray-900',
	tdWrap:
		'border-b border-gray-200 px-4 py-2.5 align-middle text-sm text-gray-900',
	tdPrimary:
		'border-b border-gray-200 px-4 py-2.5 align-middle text-sm font-medium text-primary-700',
	tdMuted:
		'whitespace-nowrap border-b border-gray-200 px-4 py-2.5 align-middle text-sm text-gray-500',
	tableFoot:
		'flex flex-wrap items-center justify-between border-t border-gray-200 px-6 py-3 text-xs text-gray-500',
	pagerBtn:
		'rounded-md border border-gray-300 bg-white px-2.5 py-1 text-xs text-gray-700 disabled:cursor-default',
	pagerBtnActive:
		'rounded-md border border-primary-500 bg-primary-500 px-2.5 py-1 text-xs text-white',
	pill: 'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2 py-1 text-xs font-medium leading-[1.3]',
	pillSuccess: 'border-green-200 bg-green-100 text-green-800',
	pillPrimary: 'border-primary-100 bg-primary-50 text-primary-700',
	pillNeutral: 'border-gray-200 bg-gray-100 text-gray-600',
	pillWarning: 'border-sand-300 bg-sand-100 text-sand-900',
	check: 'flex items-center gap-2 text-sm text-gray-900',
	checkInput: 'h-4 w-4 accent-primary-500',
	wizardStep:
		'flex flex-1 items-center justify-center gap-2 rounded-lg border bg-white p-3 text-sm font-medium',
	wizardStepNum:
		'flex h-6 w-6 flex-none items-center justify-center rounded-full text-sm font-medium not-italic',
	wizardBody: 'rounded-lg border border-gray-200 bg-white p-6',
	wizardTitle: 'mb-8 text-center',
	wizardH3: 'mb-3 text-2xl font-bold text-gray-900',
	wizardP: 'text-lg text-gray-600',
	wizardFoot: 'flex items-center justify-between py-6',
};

// The v9 step chip: done/current in navy, todo faded.
export const wizardStepClass = (state: 'done' | 'current' | 'todo') =>
	`${v9.wizardStep} ${
		state === 'current'
			? 'border-primary-500 text-primary-500'
			: state === 'done'
				? 'border-gray-200 text-primary-500'
				: 'border-gray-200 text-gray-500 opacity-50'
	}`;

export const wizardStepNumClass = (state: 'done' | 'current' | 'todo') =>
	`${v9.wizardStepNum} ${
		state === 'todo' ? 'bg-gray-200 text-gray-600' : 'bg-primary-500 text-white'
	}`;

export const formatShortDate = (iso?: string | null) =>
	iso
		? new Date(iso).toLocaleDateString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
			})
		: '—';
